module.exports = __webpack_public_path__ + "img/company.0cb04cff.png";